import React from "react";
import Select from "react-select";

// const options = [
//   { value: "chocolate", label: "Chocolate" },
//   { value: "strawberry", label: "Strawberry" },
//   { value: "vanilla", label: "Vanilla" }
// ];

export default class App extends React.Component {
  state = {
    selectedOption: null
  };
  handleChange = selectedOption => {
    const { isMulti } = this.props;
    this.setState({ selectedOption });
    if (selectedOption) {
      if (!isMulti) {
        this.props.getData(selectedOption.value);
      } else {
        const tmp = [];
        selectedOption.map(val => tmp.push(val.value));
        this.props.getData(tmp);
      }
    } else {
      this.props.getData("");
    }
  };
  render() {
    const { selectedOption } = this.state;
    const { menus, isMulti, label } = this.props;

    return (
      <Select
        value={selectedOption}
        onChange={this.handleChange}
        options={menus}
        isSearchable={false}
        isMulti={isMulti}
        placeholder={label}
        className="react-select-boot"
        classNamePrefix="react-select-bot"
      />
    );
  }
}
